export const buttonSizes = {
    '2xs': 'px-1.5 py-0.5 text-xs rounded',
    xs: 'px-2.5 rounded py-1 text-xs',
    sm: 'px-3 py-1 rounded text-xs leading-4',
    md: 'px-4 py-1.5 rounded text-sm',
    sq: 'px-2 py-2 rounded',
    lg: 'px-5 py-2 rounded text-base',
    xl: 'px-6 py-2.5 rounded text-base',
} as const

export type ButtonSize = keyof typeof buttonSizes

const focusRing = 'focus:outline-none focus:ring-2 focus:ring-offset-2 border-2 '

export const buttonVariants = {
    primary: 'bg-reflex text-white hover:bg-reflex/95 focus:ring-reflex border-transparent ' + focusRing,
    primaryOutline: 'border-reflex text-reflex hover:bg-reflex/10 focus:ring-reflex ' + focusRing,
    danger: 'bg-red-500 text-white hover:bg-red-700 focus:ring-red-500 border-transparent ' + focusRing,
    dangerOutline: 'border-red-500 text-red-500 hover:bg-red-50 focus:ring-red-300 ' + focusRing,
    default: 'bg-gray-300 text-gray-900 hover:bg-gray-400/75 focus:ring-gray-300 border-transparent ' + focusRing,
    defaultOutline: 'border-gray-300 text-gray-900 hover:bg-gray-50 focus:ring-gray-300 ' + focusRing,
    link: 'text-reflex bg-transparent hover:text-underline focus:ring-reflex border-transparent ' + focusRing,
    pill: 'bg-white text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:ring-gray-900 focus:ring-2 !border-0 !rounded-full focus:outline-none',
    pillDanger: 'bg-white text-red-500 ring-1 ring-inset ring-red-500 hover:bg-red-50 focus:ring-red-500 focus:ring-2 !rounded-full focus:outline-none',
} as const

export type ButtonVariant = keyof typeof buttonVariants

export const buttonBaseClass = 'transition-all disabled:cursor-not-allowed font-medium disabled:opacity-50 shadow-xs inline-flex items-center whitespace-nowrap justify-center'

export const getSizeClass = (size: ButtonSize): string => {
    return buttonSizes[size]
}

export const getVariantClass = (variant: ButtonVariant): string => {
    return `${buttonBaseClass} ${buttonVariants[variant]}`
}

export const makeButton = (variant: ButtonVariant = 'primary', size: ButtonSize = 'md'): string => {
    return `${getVariantClass(variant)} ${getSizeClass(size)}`
}
